<eventq-dialog-popover
  [open]="open()"
  [title]="title()"
  [titleIcon]="titleIcon()"
  [cancelLabel]="closeLabel()"
  [showConfirm]="false"
  [bodyScroll]="false"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  [panelMaxHeight]="panelMaxHeight()"
  (closed)="closed.emit()"
>
  <eventq-searchable-list
    appearance="popover"
    selectionMode="single"
    [fillHeight]="true"
    [pageSize]="50"
    [columns]="siteColumns"
    [rows]="siteRows()"
    [selectable]="allowSiteSelect()"
    [loading]="loading()"
    [skeletonCount]="skeletonCount()"
    [searchQuery]="searchQuery()"
    [searchPlaceholder]="searchPlaceholder()"
    [listAriaLabel]="title()"
    (searchQueryChange)="searchQueryChange.emit($event)"
    (itemSelect)="onSiteSelect($event)"
  />
</eventq-dialog-popover>
